import { render, staticRenderFns } from "./productSeries.vue?vue&type=template&id=1478a166&scoped=true&"
import script from "./productSeries.vue?vue&type=script&lang=js&"
export * from "./productSeries.vue?vue&type=script&lang=js&"
import style0 from "./productSeries.vue?vue&type=style&index=0&id=1478a166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478a166",
  null
  
)

export default component.exports